import { Injectable } from '@angular/core';
import { UserID } from '@common/dto/user';
import { BehaviorSubject } from 'rxjs';

export const LOCAL_STORAGE_USER_ID_KEY = 'uid';
export const LOCAL_STORAGE_TOKEN_KEY = 'access_token';
export const AUTH_REDIRECT_URL = 'auth_redirect_url';

@Injectable({ providedIn: 'root' })
export class AccountStore {
  private emailAddress$$ = new BehaviorSubject<string | null>(null);
  emailAddress$ = this.emailAddress$$.asObservable();

  get emailAddress() {
    return this.emailAddress$$.value;
  }
  set emailAddress(emailAddress: string | null) {
    this.emailAddress$$.next(emailAddress);
  }

  get userId(): UserID | null {
    return localStorage.getItem(LOCAL_STORAGE_USER_ID_KEY);
  }

  get accessToken() {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
  }

  get authRedirectUrl() {
    return sessionStorage.getItem(AUTH_REDIRECT_URL);
  }

  storeUserCredentials(
    userId: UserID,
    accessToken: string,
    emailAddress: string
  ) {
    this.emailAddress = emailAddress;
    localStorage.setItem(LOCAL_STORAGE_USER_ID_KEY, userId);
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, accessToken);
  }

  logOut(opts?: { rememberUrl: boolean }) {
    this.emailAddress = null;
    localStorage.removeItem(LOCAL_STORAGE_USER_ID_KEY);
    localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
    if (!opts || !opts.rememberUrl) {
      sessionStorage.removeItem(AUTH_REDIRECT_URL);
    }
  }

  setAuthRedirectUrl(url: string) {
    sessionStorage.setItem(AUTH_REDIRECT_URL, url);
  }

  clearAuthRedirectUrl() {
    sessionStorage.removeItem(AUTH_REDIRECT_URL);
  }
}
